/*
 *
 * Merchant action types
 *
 */

export const FETCH_MERCHANT_LIST_INITIATED = 'FETCH_MERCHANT_LIST_INITIATED';
export const FETCH_MERCHANT_LIST_SUCCESS = 'FETCH_MERCHANT_LIST_SUCCESS';
export const FETCH_MERCHANT_LIST_FAILURE = 'FETCH_MERCHANT_LIST_FAILURE';

export const FETCH_INVITEE_INITIATED = 'FETCH_INVITEE_INITIATED';
export const FETCH_INVITEE_LIST_SUCCESS = 'FETCH_INVITEE_SUCCESS';
export const FETCH_INVITEE_LIST_FAILURE = 'FETCH_INVITEE_FAILURE';

export const INVITE_USER__INITIATED = 'INVITE_USER_INITIATED';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_FAILURE = 'INVITE_USER_FAILURE';

export const INVITE_USER_UPDATE_INITIATED = 'INVITE_USER_UPDATE_INITIATED';
export const INVITE_USER_UPDATE_SUCCESS = 'INVITE_USER_UPDATE_SUCCESS';
export const INVITE_USER_UPDATE_FAILURE = 'INVITE_USER_UPDATE_FAILURE';

export const UPDATE_RESELLER_DETAILS_INITIATED = 'UPDATE_RESELLER_DETAILS_INITIATED';
export const UPDATE_RESELLER_DETAILS_SUCCESS = 'UPDATE_RESELLER_DETAILS_SUCCESS';
export const UPDATE_RESELLER_DETAILS_FAILURE = 'UPDATE_RESELLER_DETAILS_FAILURE';


export const FETCH_RESELLER_DETAILS_INITIATED = 'FETCH_RESELLER_DETAILS_INITIATED';
export const FETCH_RESELLER_DETAILS_SUCCESS = 'FETCH_RESELLER_DETAILS_SUCCESS';
export const FETCH_RESELLER_DETAILS_FAILURE = 'FETCH_RESELLER_DETAILS_FAILURE';

export const FETCH_BUSINESS_ENTITIES_INITIATED = 'FETCH_BUSINESS_ENTITIES_INITIATED';
export const FETCH_BUSINESS_ENTITIES_SUCCESS = 'FETCH_BUSINESS_ENTITIES_SUCCESS';
export const FETCH_BUSINESS_ENTITIES_FAILURE = 'FETCH_BUSINESS_ENTITIES_FAILURE';

export const REFER_MERCHANT_INITIATED = 'REFER_MERCHANT_INITIATED';
export const REFER_MERCHANT_SUCCESS = 'REFER_MERCHANT_SUCCESS';
export const REFER_MERCHANT_FAILURE = 'REFER_MERCHANT_FAILURE';
export const FETCH_RESELLER_AGREEMENT_INITIATED = 'FETCH_RESELLER_AGREEMENT_INITIATED';
export const FETCH_RESELLER_AGREEMENT_SUCCESS = 'FETCH_RESELLER_AGREEMENT_SUCCESS';
export const FETCH_RESELLER_AGREEMENT_FAILURE = 'FETCH_RESELLER_AGREEMENT_FAILURE';

export const SEND_SMS_LINK_REQUEST_INITIATED = 'SEND_SMS_LINK_REQUEST_INITIATED';
export const SEND_SMS_LINK_REQUEST_SUCCESS = 'SEND_SMS_LINK_REQUEST_SUCCESS';
export const SEND_SMS_LINK_REQUEST_FAILURE = 'SEND_SMS_LINK_REQUEST_FAILURE';

export const SET_MERCHANTLIST_FILTER = 'SET_MERCHANTLIST_FILTER';
export const SET_APPLIED_FILTER = 'SET_APPLIED_FILTER';

export const FETCH_BUSINESS_CATEGORIES_INITIATED = 'FETCH_BUSINESS_CATEGORIES_INITIATED';
export const FETCH_BUSINESS_CATEGORIES_SUCCESS = 'FETCH_BUSINESS_CATEGORIES_SUCCESS';
export const FETCH_BUSINESS_CATEGORIES_FAILURE = 'FETCH_BUSINESS_CATEGORIES_FAILURE';

export const FETCH_RESELLER_BUSINESS_CATEGORIES_INITIATED = 'FETCH_RESELER_BUSINESS_CATEGORIES_INITIATED';
export const FETCH_RESELLER_BUSINESS_CATEGORIES_SUCCESS = 'FETCH_RESELER_BUSINESS_CATEGORIES_SUCCESS';
export const FETCH_RESELLER_BUSINESS_CATEGORIES_FAILURE = 'FETCH_RESELER_BUSINESS_CATEGORIES_FAILURE';

export const FETCH_TIMELINE_STATUS_INITIATED = 'FETCH_TIMELINE_STATUS_INITIATED';
export const FETCH_TIMELINE_STATUS_SUCCESS = 'FETCH_TIMELINE_STATUS_SUCCESS';
export const FETCH_TIMELINE_STATUS_FAILED = 'FETCH_TIMELINE_STATUS_FAILED';
export const PROFILE_COMPLETED_FOR_TIMELINE = 'PROFILE_COMPLETED_FOR_TIMELINE';

export const FETCH_BANK_NAMES_FOR_IFSC_SUCCESS = 'FETCH_BANK_NAMES_FOR_IFSC_SUCCESS';
export const FETCH_BANK_CITIES_FOR_IFSC_SUCCESS = 'FETCH_BANK_CITIES_FOR_IFSC_SUCCESS';
export const FETCH_BANK_STATES_FOR_IFSC_SUCCESS = 'FETCH_BANK_STATES_FOR_IFSC_SUCCESS';
export const FETCH_BANK_BRANCHES_FOR_IFSC_SUCCESS = 'FETCH_BANK_BRANCHES_FOR_IFSC_SUCCESS';
export const FETCH_RESELLER_INCENTIVE_INITIATED = 'FETCH_RESELLER_INCENTIVE_INITIATED';
export const FETCH_RESELLER_INCENTIVE_SUCCESS = 'FETCH_RESELLER_INCENTIVE_SUCCESS';
export const FETCH_RESELLER_INCENTIVE_FAILURE = 'FETCH_RESELLER_INCENTIVE_FAILURE';
export const UPDATE_INVITEE_DATA = 'UPDATE_INVITEE_DATA';
export const UPDATE_MERCHANT_DATA = 'UPDATE_MERCHANT_DATA';
export const CREATE_APP_SUBMIT_INITIATED = 'CREATE_APP_SUBMIT_INITIATED';
export const CREATE_APP_FAILURE = 'CREATE_APP_FAILURE';
export const CREATE_APP_SUCCESS = 'CREATE_APP_SUCCESS';
export const CREATE_INCORRECT_PASSWORD = 'CREATE_INCORRECT_PASSWORD';
export const SHOW_INCORRECT_PASSWORD = 'SHOW_INCORRECT_PASSWORD';
export const FETCH_APP_DETAILS_INITIATED = 'FETCH_APP_DETAILS_INITIATED';
export const FETCH_APP_DETAILS_SUCCESS = 'FETCH_APP_DETAILS_SUCCESS';
export const FETCH_APP_DETAILS_FAILURE = 'FETCH_APP_DETAILS_FAILURE';
export const UPLOAD_ICON_INITIATED = 'UPLOAD_ICON_INITIATED';
export const UPLOAD_ICON_SUCCESS = 'UPLOAD_ICON_SUCCESS';
export const UPLOAD_ICON_FAILURE = 'UPLOAD_ICON_FAILURE';
export const REMOVE_ICON_INITIATED = 'REMOVE_ICON_INITIATED';
export const REMOVE_ICON_SUCCESS = 'REMOVE_ICON_SUCCESS';
export const REMOVE_ICON_FAILURE = 'REMOVE_ICON_FAILURE';
export const BRANDING_DETAILS_INITIATED = 'BRANDING_DETAILS_INITIATED';
export const BRANDING_DETAILS_SUCCESS = 'BRANDING_DETAILS_SUCCESS';
export const BRANDING_DETAILS_FAILURE = 'BRANDING_DETAILS_FAILURE';
export const CREATE_MERCHANT_STAFF_INITIATED = 'CREATE_MERCHANT_STAFF_INITIATED';
export const CREATE_MERCHANT_STAFF_SUCCESS = 'CREATE_MERCHANT_STAFF_SUCCESS';
export const CREATE_MERCHANT_STAFF_FAILURE = 'CREATE_MERCHANT_STAFF_FAILURE';